import { Divider, Tooltip } from "@mui/material";
import { ActionStatus } from "shared";
import { When } from "react-if";
import { FunnelIcon } from "@heroicons/react/24/outline";

import { Button } from "../../../common/Atoms/Button";
import { QuickFilterTypes, useActionTableModels } from "../../hooks/useActions";

export function ActionQuickFilters() {
  const { onQuickFilter, currentTab } = useActionTableModels();

  const hasFilters = currentTab === ActionStatus.PENDING || currentTab === ActionStatus.COMPLETE;

  if (!hasFilters) {
    return null;
  }

  return (
    <>
      <div className={ `space-x-2` }>
        <When condition={ currentTab === ActionStatus.PENDING }>
          <Tooltip title={ `Actions that are pending and also due to be processed within immediately` }>
            <Button
              color={ `paidniceGreenOutline` }
              size={ `sm` }
              onClick={ () => onQuickFilter(QuickFilterTypes.pendingAndDue) }
            >
              <FunnelIcon className={ `w-4 h-4 mr-1` } />
              { `Scheduled Now` }
            </Button>
          </Tooltip>
        </When>

        <When condition={ currentTab === ActionStatus.COMPLETE }>
          <Tooltip title={ `View successful actions completed in the last 2 days` }>
            <Button
              color={ `paidniceGreenOutline` }
              size={ `sm` }
              onClick={ () => onQuickFilter(QuickFilterTypes.recentlyCompleted) }
            >
              <FunnelIcon className={ `w-4 h-4 mr-1` } />
              { `Recently Complete` }
            </Button>
          </Tooltip>
        </When>
      </div>

      { /* Only show divider when buttons exist (hasFilters = true) */ }
      <Divider
        orientation={ `vertical` }
        flexItem
        className={ `pl-2` }
      />
    </>
  );
}
